import { render, staticRenderFns } from "./weekSoft.vue?vue&type=template&id=2a4755ea&scoped=true&"
import script from "./weekSoft.vue?vue&type=script&lang=js&"
export * from "./weekSoft.vue?vue&type=script&lang=js&"
import style0 from "./weekSoft.vue?vue&type=style&index=0&id=2a4755ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4755ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4755ea')) {
      api.createRecord('2a4755ea', component.options)
    } else {
      api.reload('2a4755ea', component.options)
    }
    module.hot.accept("./weekSoft.vue?vue&type=template&id=2a4755ea&scoped=true&", function () {
      api.rerender('2a4755ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/week/weekSoft.vue"
export default component.exports